<template>
  <div
    class="card-link"
    role="button"
    tabindex="0"
    @click="$emit('select')"
    @keydown.enter="$emit('select')"
    @keydown.space.prevent="$emit('select')"
  >
    <div class="card">
      <img
        :src="photo"
        :alt="name"
      />
      <div class="text">
        <div class="title">{{ title }}</div>
        <div class="position">
          <IconBase name="location" />
          {{ position }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconBase from '@/shared/ui/IconBase.vue';

  defineProps<{
    title: string;
    name: string;
    position: string;
    photo: string;
  }>();

  defineEmits<{
    (e: 'select'): void;
  }>();
</script>

<style scoped lang="scss">
  .card-link {
    display: block;
    cursor: pointer;
  }

  .card {
    position: relative;
    display: block;
    width: 100%;
    height: 298px;
    overflow: hidden;
    border-radius: 16px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }

    .text {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
      padding: 32px 16px 16px;
      color: var(--alias-color-text-inverse);
      background: linear-gradient(
        180deg,
        rgb(0 0 0 / 0%) 0%,
        rgb(0 0 0 / 1%) 2.98%,
        rgb(0 0 0 / 2%) 9.73%,
        rgb(0 0 0 / 5%) 15.18%,
        rgb(0 0 0 / 8%) 19.56%,
        rgb(0 0 0 / 13%) 23.11%,
        rgb(0 0 0 / 18%) 26.06%,
        rgb(0 0 0 / 23%) 28.65%,
        rgb(0 0 0 / 29%) 31.13%,
        rgb(0 0 0 / 35%) 33.72%,
        rgb(0 0 0 / 41%) 36.67%,
        rgb(0 0 0 / 47%) 40.22%,
        rgb(0 0 0 / 53%) 44.6%,
        rgb(0 0 0 / 59%) 50.04%,
        rgb(0 0 0 / 63%) 56.8%
      );

      &::before {
        position: absolute;
        inset: 0;
        z-index: -1;
        content: '';
        backdrop-filter: blur(3.5px);
        mask-image: linear-gradient(to top, rgb(0 0 0) 60%, transparent 100%);
      }

      .title {
        @include base-400-300-semi;

        @include mobile {
          @include base-300-300-semi;
        }
      }

      .position {
        display: flex;
        gap: 4px;
        align-items: center;
        margin-top: 8px;

        @include base-300-300-medium;
      }
    }

    @include mobile {
      height: 232px;
    }
  }
</style>
